export enum FreeWallType {
    Qa = 'qa',
    Video = 'video',
    Other = 'other'
}
